export default __webpack_public_path__ + "static/media/ava-03.67407cba.png";